import React, { Component } from 'react';
import ReactExport from 'react-data-export';
import moment from 'moment';
import { consulta, coloresEmma } from '../../../global/js/funciones';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const argb = (hex) => `FF${`${hex || ''}`.replace('#', '').toUpperCase()}`;

const ESTILO_ENCABEZADO = {
  fill: { patternType: 'solid', fgColor: { rgb: argb(coloresEmma.fondocolor) } },
  font: { sz: '11', bold: true, color: { rgb: argb(coloresEmma.primarycolor) }, name: 'Arial Narrow' },
  alignment: { vertical: 'center', horizontal: 'center', wrapText: true },
};

// Componente invisible, como DescargarPdfRegistro: se monta y descarga el Excel.
class ExportarMovEstudiantilExcel extends Component {

  constructor(props) {
    super(props);
    this.state = { columnas: [], valores: [], nombre: '' };
    this.descargado = false;
  }

  async componentDidMount() {
    let { id_solicitud, actualizarMensaje, no_cargando } = this.props;
    let data = await this.obtenerInfoSolicitud(id_solicitud);
    if (!data || !data.movilidad) {
      actualizarMensaje({ titulo: 'No fue posible obtener la información de la solicitud.', tipo: 'error', mostrar: true, tiempo: 6000 });
      no_cargando();
      return;
    }
    try {
      this.setState(this.armarHoja(data));
    } catch (e) {
      actualizarMensaje({ titulo: 'Ha ocurrido un error generando el archivo.', tipo: 'error', mostrar: true, tiempo: 6000 });
      no_cargando();
    }
  }

  componentDidUpdate() {
    let { actualizarMensaje, no_cargando } = this.props;
    if (this.descargado || this.state.columnas.length === 0 || !this.boton) return;
    this.descargado = true;
    this.boton.click();
    actualizarMensaje({ titulo: 'Descarga generada correctamente.', tipo: 'success', mostrar: true, tiempo: 4000 });
    no_cargando();
  }

  obtenerInfoSolicitud(id) {
    return new Promise(resolve => {
      consulta(`api/v1.0/internacionalizacion/solicitud/${id}/exportar_mov_estudiantil`, null, null, (error, estado, resp) => {
        resolve(estado === 200 && !error ? resp : null);
      });
    });
  }

  obj = (o) => (o ? o : {})

  texto = (v) => (v === null || v === undefined ? '' : `${v}`)

  fecha = (v, con_hora = false) => {
    if (!v) return '';
    let m = moment(v);
    if (!m.isValid()) return v;
    return m.format(con_hora ? 'DD-MM-YYYY hh:mm a' : 'DD-MM-YYYY');
  }

  nombreCompleto = (p) => {
    let per = this.obj(p);
    return [per.primer_nombre, per.segundo_nombre, per.primer_apellido, per.segundo_apellido]
      .filter(Boolean).join(' ');
  }

  celular = (p) => {
    let per = this.obj(p);
    if (!per.celular) return '';
    return per.indicativo_celular ? `+${per.indicativo_celular} ${per.celular}` : `${per.celular}`;
  }

  armarHoja = (data) => {
    let solicitud = this.obj(data.solicitud);
    let mov = this.obj(data.movilidad);
    let per = this.obj(mov.usuario_registro);
    let conv = this.obj(mov.convocatoria);

    let columnas = [];
    const campo = (seccion, etiqueta, valor, ancho = 24) =>
      columnas.push({ titulo: `${seccion}: ${etiqueta}`, valor: this.texto(valor), ancho });

    campo('Solicitud', 'Número', solicitud.id, 12);
    campo('Solicitud', 'Tipo', this.obj(solicitud.tipo_solicitud).nombre, 30);
    campo('Solicitud', 'Periodo', solicitud.periodo, 10);
    campo('Solicitud', 'Estado actual', this.obj(solicitud.estado_actual).nombre, 18);
    campo('Solicitud', 'Fecha de registro', this.fecha(solicitud.fecha_registro, true), 20);

    campo('Convocatoria', 'Nombre', conv.nombre_convocatoria, 34);
    campo('Convocatoria', 'Fecha de inicio', this.fecha(conv.fecha_inicio), 16);
    campo('Convocatoria', 'Fecha de cierre', this.fecha(conv.fecha_final), 16);
    campo('Convocatoria', 'Tipo de movilidad', this.obj(conv.tipo_mov_estudiantil).nombre, 24);
    campo('Convocatoria', 'Modalidad', this.obj(conv.modalidad).nombre, 18);
    campo('Convocatoria', 'Semestre mínimo', this.obj(conv.semestre_minimo).nombre, 16);
    campo('Convocatoria', 'Promedio requerido', conv.promedio_requerido, 16);
    campo('Convocatoria', 'Universidades permitidas', conv.cantidad_universidades, 16);

    campo('Estudiante', 'Nombre completo', this.nombreCompleto(per), 32);
    campo('Estudiante', 'Identificación', per.identificacion, 16);
    campo('Estudiante', 'Correo institucional', per.correo, 28);
    campo('Estudiante', 'Correo personal', per.correo_personal, 28);
    campo('Estudiante', 'Celular', this.celular(per), 18);
    campo('Estudiante', 'Teléfono', per.telefono, 16);
    campo('Estudiante', 'Fecha de nacimiento', this.fecha(per.fecha_nacimiento), 18);
    campo('Estudiante', 'Género', this.obj(per.genero).nombre, 14);
    campo('Estudiante', 'Nacionalidad', per.nacionalidad, 18);
    campo('Estudiante', 'Lugar de residencia', per.lugar_residencia, 22);
    campo('Estudiante', 'Dirección de residencia', per.direccion, 28);

    campo('Acudiente', 'Nombre completo', mov.acudiente, 32);
    campo('Acudiente', 'Parentesco', mov.parentesco, 16);
    campo('Acudiente', 'Correo', mov.correo_acudiente, 28);
    campo('Acudiente', 'Celular', mov.celular_acudiente, 18);
    campo('Acudiente', 'Departamento de residencia', mov.lugar_residencia_acudiente, 24);
    campo('Acudiente', 'Ciudad de residencia', mov.ubicacion_residencia_acudiente, 22);
    campo('Acudiente', 'Dirección de residencia', mov.direccion_residencia_acudiente, 28);

    campo('Académica', 'Programa académico', this.obj(mov.programa_academico).nombre, 30);
    campo('Académica', 'Semestre actual', mov.semestre_actual, 14);
    campo('Académica', 'Promedio acumulado', mov.promedio_acumulado, 16);

    // Las cuatro columnas salen siempre, aunque esten vacias: con una sola fila de
    // datos, una hoja de ancho fijo es mas facil de comparar entre solicitudes.
    [1, 2, 3, 4].forEach((i) => {
      let univ = this.obj(mov[`universidad_${i}`]);
      campo('Destino', `Opción ${i}`, univ.nombre, 34);
      campo('Destino', `Opción ${i} - País`, univ.valora, 18);
    });
    campo('Destino', 'Institución asignada', this.obj(mov.universidad_seleccionada).nombre, 34);

    let sello = moment().format('YYYY-MM-DD, h.mm a');
    return {
      columnas,
      valores: columnas.map(({ valor }) => ({ value: valor })),
      nombre: `Movilidad Estudiantil - Solicitud ${this.texto(solicitud.id)} - ${sello}`,
    };
  }

  render() {
    let { columnas, valores, nombre } = this.state;
    if (columnas.length === 0) return null;
    let dataSet = [{
      columns: columnas.map(({ titulo, ancho }) => ({
        title: titulo, width: { wch: ancho }, style: ESTILO_ENCABEZADO,
      })),
      data: [valores],
    }];
    return (
      <ExcelFile
        filename={nombre}
        element={<button ref={(b) => { this.boton = b; }} style={{ display: 'none' }}>Descargar</button>}
      >
        <ExcelSheet dataSet={dataSet} name="Solicitud" />
      </ExcelFile>
    );
  }
}

export default ExportarMovEstudiantilExcel;
